import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About/index.vue'),
    meta: {
      title: '关于研究院'
    }
  },
  {
    path: '/research',
    name: 'Research',
    component: () => import('@/views/Research/index.vue'),
    meta: {
      title: '科学研究'
    }
  },
  {
    path: '/education',
    name: 'Education',
    component: () => import('@/views/Education/index.vue'),
    meta: {
      title: '人才培养'
    }
  },
  {
    path: '/innovation',
    name: 'Innovation',
    component: () => import('@/views/Innovation/index.vue'),
    meta: {
      title: '创新基地'
    }
  },
  {
    path: '/party',
    name: 'Party',
    component: () => import('@/views/Party/index.vue'),
    meta: {
      title: '党群文化'
    }
  },
  {
    path: '/hr',
    name: 'HR',
    component: () => import('@/views/HR/index.vue'),
    meta: {
      title: '人力资源'
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/Search/index.vue'),
    meta: {
      title: '搜索结果'
    }
  },
  {
    path: '/news',
    name: 'NewsList',
    component: () => import('@/views/News/NewsList.vue'),
    meta: {
      title: '新闻列表'
    }
  },
  {
    path: '/news/detail/:id',
    name: 'NewsDetail',
    component: () => import('@/views/News/NewsDetail.vue'),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/event',
    name: 'Event',
    component: () => import('@/views/Event/index.vue'),
    meta: {
      title: '活动预告'
    }
  },
  {
    path: '/event/detail/:id',
    name: 'EventDetail',
    component: () => import('@/views/Event/detail.vue'),
    meta: {
      title: '活动详情'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

export default router 